import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'

export const StyledRadioImageGroup = styled.div`
  display: flex;
  width: 100%;

  &[data-direction='vertical'] {
    flex-direction: column;
  }

  &[data-direction='horizontal'] {
    flex-wrap: wrap;
  }
`

export const StyledRadioImageItem = styled.div`
  display: flex;

  padding: 8px;

  border-radius: ${theme.borderRadius};
  cursor: pointer;

  & > div {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  &[data-selected='true'] {
    border: 1px solid #2d87f3;
    background: white;

    .radio-group-item-heading {
      color: #2d87f3;
    }
  }
  &[data-selected='false'] {
    border: 1px solid #f2f2f2;
    box-shadow: 0px 5px 12px rgba(40, 74, 117, 0.08);
    .radio-group-item-heading {
      color: #262626;
    }
  }
  &[data-disabled='true'] {
    cursor: auto;
  }

  .radio-group-item-heading {
    margin-top: 8px;
    text-align: center;
  }

  .gender-image {
    width: 23px;
    height: 36px;
    object-fit: contain;
  }
`
